module.exports = __webpack_public_path__ + "static/media/DonateCarousel_2.5b7829a0.jpg";